import {
  EmptyState,
  FormFeedBack,
  InfiniteScrollLoading,
  MainButton,
  PageWrapper,
  Select,
  STATUSPAGE,
} from '@repo/ui';
import { CpfInput } from 'adasi_components';
import FeatherIcon from 'feather-icons-react';
import { useNavigate } from 'react-router-dom';
import { Col, Row, Card, Form, Input, Label } from 'reactstrap';

import { PersonDetailsOffcanvas } from '../../components/person-details-offcanvas';
import { PersonListGridCard } from '../../components/person-list-grid-card';
import { usePersonsList } from '../../hooks/use-persons-list';

export function PersonList() {
  const navigate = useNavigate();

  const {
    changeDataViewMode,
    requestGetOffcanvasData,
    togglePersonDetailsOffcanvas,
    clearPersonDetailsOffcanvasData,
    lastPersonListGridCardCallbackRef,
    validation,
    dataViewMode,
    profileTypeOptions,
    requestsStatus,
    personsListData,
    personsListHasNextPage,
    personDetailsOffcanvasData,
    isPersonDetailsOffcanvasOpen,
  } = usePersonsList();

  // Constants
  const noDataConfig = {
    noDataTitle: 'Encontre pessoas no sistema',
    noDataDescription:
      'Use os filtros acima para pesquisar pessoas por nome, CPF ou e-mail.',
  };
  const profileTypeErrorMessage =
    typeof validation.errors.profileType === 'string'
      ? validation.errors.profileType
      : undefined;

  return (
    <PageWrapper title="Pessoas">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 className="fw-bold">Pessoas</h4>
          <p className="text-muted mb-0">
            Pesquise todas as pessoas que estão cadastradas no sistema, desde
            gestores até estudantes.
          </p>
        </div>
      </div>
      <Card className="p-3">
        <Form onSubmit={validation.handleSubmit}>
          <Row className="align-items-end">
            <Col sm={6} lg={2} className="mb-3 mb-sm-0">
              <Label htmlFor="profileType" className="form-label">
                Perfil
              </Label>
              <Select
                id="profileType"
                name="profileType"
                value={validation.values.profileType}
                options={profileTypeOptions}
                placeholder="Todos os perfis"
                isClearable
                onChange={(option) => {
                  validation.setFieldValue('profileType', option);
                }}
                onBlur={() => {
                  validation.setFieldTouched('profileType', true);
                }}
                invalid={
                  !!(
                    validation.touched.profileType &&
                    validation.errors.profileType
                  )
                }
              />
              <FormFeedBack
                error={profileTypeErrorMessage}
                isInvalid={
                  !!(
                    validation.touched.profileType &&
                    validation.errors.profileType
                  )
                }
              />
            </Col>
            <Col sm={6} lg={3} className="mb-3 mb-sm-0">
              <Label htmlFor="name" className="form-label">
                Nome
              </Label>
              <Input
                tabIndex={1}
                id="name"
                autoFocus
                type="text"
                name="name"
                className="form-control"
                value={validation.values.name}
                onChange={validation.handleChange}
                invalid={validation.touched.name && !!validation.errors.name}
              />
              <FormFeedBack
                error={validation?.errors?.name}
                isInvalid={
                  !!(validation?.touched?.name && validation?.errors?.name)
                }
              />
            </Col>
            <Col sm={6} lg={2} className="mb-3 mb-sm-0">
              <Label htmlFor="cpf" className="form-label">
                CPF
              </Label>
              <CpfInput
                tabIndex={2}
                name="cpf"
                inputId="cpf"
                className="form-control"
                value={validation.values.cpf}
                handleChange={validation.handleChange}
                invalid={!!(validation.touched.cpf && validation.errors.cpf)}
              />
              <FormFeedBack
                error={validation?.errors?.cpf}
                isInvalid={
                  !!(validation?.touched?.cpf && validation?.errors?.cpf)
                }
              />
            </Col>
            <Col sm={6} lg={3} className="mb-3 mb-sm-0">
              <Label htmlFor="name" className="form-label">
                E-mail
              </Label>
              <Input
                id="email"
                type="email"
                tabIndex={3}
                name="email"
                className="form-control"
                value={validation.values.email}
                onChange={validation.handleChange}
                invalid={validation.touched.email && !!validation.errors.email}
              />
              <FormFeedBack
                error={validation?.errors?.email}
                isInvalid={
                  !!(validation?.touched?.email && validation?.errors?.email)
                }
              />
            </Col>
            <Col sm={12} lg={2} className="mb-3 mb-sm-0">
              <div className="d-flex flex-row gap-2">
                <MainButton
                  type="submit"
                  tabIndex={5}
                  isDisabled={
                    requestsStatus.getAllPersons === STATUSPAGE.LOADING
                  }
                  isLoading={
                    requestsStatus.getAllPersons === STATUSPAGE.LOADING
                  }
                  className="align-self-end w-100"
                >
                  Pesquisar
                </MainButton>
                <MainButton
                  type="button"
                  color="soft-info"
                  aria-label="Visualização em grid"
                  onClick={() => changeDataViewMode('grid')}
                  className={`btn-icon nav-link ${dataViewMode === 'grid' ? 'active' : ''}`}
                  style={{ minWidth: 36 }}
                >
                  <FeatherIcon size={18} icon="grid" />
                </MainButton>
                <MainButton
                  type="button"
                  color="info"
                  aria-label="Visualização em lista"
                  onClick={() => changeDataViewMode('list')}
                  className={`btn-icon nav-link ${dataViewMode === 'list' ? 'active' : ''}`}
                  style={{ minWidth: 36 }}
                >
                  <FeatherIcon size={18} icon="list" />
                </MainButton>
              </div>
            </Col>
          </Row>
        </Form>
      </Card>

      {(personsListData.data.length === 0 ||
        personsListData.data === null ||
        personsListData.data === undefined) &&
        requestsStatus.getAllPersons !== STATUSPAGE.LOADING && (
          <Card>
            <EmptyState
              variant="search"
              title={noDataConfig.noDataTitle}
              description={noDataConfig.noDataDescription}
              size={100}
              paddingY={3}
            />
          </Card>
        )}

      {personsListData.data.length > 0 && (
        <Row
          className={`team-list ${dataViewMode}-view-filter ${!personsListHasNextPage && 'mb-3'}`}
        >
          {personsListData.data.map((personData, idx) => {
            return (
              <PersonListGridCard
                key={personData.id}
                ref={
                  personsListData.data.length === idx + 1
                    ? lastPersonListGridCardCallbackRef
                    : undefined
                }
                dataViewMode={dataViewMode}
                personData={personData}
                onNameClick={() => {
                  togglePersonDetailsOffcanvas();
                  requestGetOffcanvasData(personData.id);
                }}
                onViewProfileBtnClick={() => {
                  navigate(`/pessoas/${personData.id}`);
                }}
              />
            );
          })}
        </Row>
      )}

      {requestsStatus.getAllPersons === STATUSPAGE.LOADING && (
        <InfiniteScrollLoading
          isFirstLoading={personsListData.data.length === 0}
        />
      )}

      <PersonDetailsOffcanvas
        isOpen={isPersonDetailsOffcanvasOpen}
        toggle={togglePersonDetailsOffcanvas}
        onClosed={() => {
          clearPersonDetailsOffcanvasData();
        }}
        isLoading={requestsStatus.getOffcanvasData === STATUSPAGE.LOADING}
        personData={personDetailsOffcanvasData.person}
        personProfilesData={personDetailsOffcanvasData.profiles}
        onViewProfileBtnClick={(personData) =>
          navigate(`/pessoas/${personData.id}`)
        }
      />
    </PageWrapper>
  );
}
